import React, { forwardRef, ForwardRefRenderFunction, useImperativeHandle, useRef, useState } from 'react';

import { TrashIcon, Upload } from '@/components';
import { compressImage, getBase64 } from '@/utils';

import ImageCropper from './index';

// eslint-disable-next-line no-empty-pattern
const ImageUploadWithCropper: ForwardRefRenderFunction<{ getImage: () => string }> = ({}, ref) => {
  const [uploadSign, setUploadSign] = useState<string>('');
  const copperRef = useRef<{ getImage: () => string }>(null);

  const onFileChange = async (file: File) => {
    const result = await compressImage(file, {
      maxWidth: 500,
      maxHeight: 500
    });
    getBase64(result as File, (base64) => {
      setUploadSign(base64);
    });
  };

  useImperativeHandle(ref, () => {
    return {
      getImage: () => copperRef.current?.getImage() as string
    };
  });

  return (
    <div className={'relative w-full h-[262px]'}>
      {uploadSign ? (
        <>
          <ImageCropper image={uploadSign} ref={copperRef} />
          <div
            className="absolute right-[18px] top-[16px] cursor-pointer"
            onClick={() => {
              setUploadSign('');
            }}
          >
            <TrashIcon stroke={'#FFF'} />
          </div>
        </>
      ) : (
        <Upload
          getFile={onFileChange}
          accept={'image/png, image/jpeg'}
          description={'Supported formats: JPG, PNG'}
          className="w-full h-[262px]"
        />
      )}
    </div>
  );
};

export default forwardRef(ImageUploadWithCropper);
